import React from 'react';
import classNames from 'classnames';
import styles from './BorderedIcon.module.scss';
import SVGIcon from './SVGIcon';

type SVGIconProps = Omit<React.ComponentProps<typeof SVGIcon>, 'children'>;

interface BorderedIconProps extends SVGIconProps {
  children: React.ReactNode;
  variant?: 'topic';
}

const BorderedIcon = ({
  children,
  variant,
  ...svgIconProps
}: BorderedIconProps) => {
  return (
    <div
      className={classNames(
        styles.container,
        variant ? styles[variant] : undefined,
      )}
    >
      {typeof children === 'string' ? (
        <SVGIcon {...svgIconProps}>{children}</SVGIcon>
      ) : (
        children
      )}
    </div>
  );
};

export default BorderedIcon;
